import PropTypes from 'prop-types'
import classNames from 'classnames'
import css from './empty-cart.scss'

const EmptyCart = ({ className }) => {
  return (
    <div className={classNames('text-center', className)}>
      <p>
        <span className={css.emptyCartIcon} />
      </p>
      <p className="text-muted">Your cart is currently empty</p>
    </div>
  )
}

EmptyCart.propTypes = {
  className: PropTypes.string,
}

export default EmptyCart
